export default __webpack_public_path__ + "static/2-2d42f80ccafbec5ec5e15ef20468d3ca.png";